import Vue from "vue";
import VueAxios from "vue-axios";
import axios from "axios";

Vue.use(VueAxios, axios);

const setDefaults = () => {
	axios.defaults.headers.common["token"] = process.env.VUE_APP_SECRET;
	axios.defaults.baseURL = process.env.VUE_APP_API_ENDPOINT;
};

async function getMenuFromApi() {
	return Vue.axios.get("/api/v1/content/menu");
}

async function getContentFromApi() {
	return Vue.axios.get("/api/v1/content/texts");
}

async function getContent() {
	return Promise.all([getMenuFromApi(), getContentFromApi()]);
}

const api = {
	setDefaults,
	getContent
};

export default api;
